    
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import Spinner from "@/components/utils/Spinner.vue";

import "@/store/modules/common";
import { locationsInfoType } from '@/types/Common';
const commonState = namespace("Common");
import moment from "moment-timezone";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";


@Component({
    components:{  
        LegalAssistanceFaq,
        Spinner
    }
})
export default class RejectedPackageInstructions extends Vue {

    @Prop({required: true})
    applicationId!: string;

    @Prop({required: true})
    packageId!: string;

    @Prop({required: true})
    packageResults!: any;

    @commonState.State
    public locationsInfo!: locationsInfoType[];

  

    dataReady = false;
    showLegalAssistance = false;
    generatedRejected = false;
    attachedRejected = false;

    loadingData = false;
    submissionResults = [];
    courtFileNumber = ''
    courtFileLocation = ''
    onlyAttachments = true
    error = ''

    submissionFields = [
        { key: 'name',        label: 'File',        sortable:false,  tdClass: '', thStyle:'width:25%;'},
        { key: 'attachment',  label: 'Attachment',  sortable:false,  tdClass: 'text-center', thStyle:'width:10%;'},
        { key: 'type',        label: 'Type',        sortable:false,  tdClass: '', thStyle:'width:8%;'},
        { key: 'description', label: 'Description', sortable:false,  tdClass: '', thStyle:'width:45%;'},        
        { key: 'status',      label: 'Status',      sortable:false,  tdClass: '', thStyle:'width:12%;'},       
    ]

    mounted(){
        this.dataReady = false;
        this.loadingData = false;
        this.showLegalAssistance = false;

        this.extractResults() 
        Vue.nextTick(()=> this.dataReady = true);
    } 

    public downloadNotice(){
        
        if(!this.packageId || this.loadingData) return        
        this.loadingData = true;
        const url = `/efiling/${this.applicationId}/rejection/${this.packageId}/`
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = "registry_notice.pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);           
            this.loadingData = false;
        },err => {
            console.error(err);
            this.loadingData = false;
        });

    }

    public extractResults(){
        this.submissionResults = [];
        
        if(this.packageResults?.documents){
            for(const doc of this.packageResults.documents){
                this.submissionResults.push({
                    name: doc.documentProperties?.name?.replace('_generated',''),
                    type: doc.documentProperties?.type,
                    status: doc.status?.description,
                    identifier: doc.identifier,
                    description: doc.description,
                    attachment: doc.documentProperties?.name?.includes('_generated')
                })
                   
                if(doc.documentProperties?.name?.includes('_generated') && doc.status?.code?.toUpperCase().includes('REJ')){
                    this.generatedRejected = true;
                    this.onlyAttachments = false;
                }

                if(!doc.documentProperties?.name?.includes('_generated') && doc.status?.code?.toUpperCase().includes('REJ'))
                    this.attachedRejected = true;
            }
        }        
        this.courtFileLocation = this.packageResults?.court?.location? this.packageResults.court.location: ''
        this.courtFileNumber = this.packageResults?.court?.fileNumber? this.packageResults.court.fileNumber: ''
    }

    public correctApplication(){
        const url = `/efiling/${this.applicationId}/rejection/${this.packageId}/`
        
        const body ={            
            lastUpdate: moment().format(),
            previousApp:{
                packageResults: this.submissionResults,
                courtFileNo: this.courtFileNumber,
                packageNumber: this.packageId,
                courtFileLocation: this.courtFileLocation,
                onlyAttachments: this.onlyAttachments
            }            
        }
        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }
        this.$http.post(url, body, header)
        .then((response) => {
            if(response.data.app_id)
                this.$emit('resumeApp', response.data.app_id)

        }, err => {
            this.error = err;        
        });
    }

}
